const base_domain = 'https://database.ecunewexperience.com'
//const base_domain = 'http://127.0.0.1:8000'

export default base_domain; 